// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","activeColor":"#7cf4fe","primaryBackgroundColor":"#140046"};